import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';
import * as DashboardActions from './dashboard.actions';

import { DashboardEntity } from './dashboard.models';

export const DASHBOARD_FEATURE_KEY = 'dashboard';

export interface DashboardState extends EntityState<DashboardEntity> {
  selectedId?: string | number; // which Dashboard record has been selected
  loaded: boolean; // has the Dashboard list been loaded
  error?: string | null; // last known error (if any)
  userDashboardData: any;
}

export interface DashboardPartialState {
  readonly [DASHBOARD_FEATURE_KEY]: DashboardState;
}

export const dashboardAdapter: EntityAdapter<DashboardEntity> =
  createEntityAdapter<DashboardEntity>();

export const initialDashboardState: DashboardState = dashboardAdapter.getInitialState({
  loaded: false,
  userDashboardData: null,
});

const reducer = createReducer(
  initialDashboardState,
  on(DashboardActions.getDashboardData, (state, payload) => {
    return { ...state, payload: payload, loaded: false, error: null };
  }),
  on(DashboardActions.getDashboardDataSuccess, (state, { userDashboardData }) => {
    return { ...state, userDashboardData: userDashboardData, loaded: true };
  }),
  on(DashboardActions.getDashboardDataFailure, (state, { error }) => ({ ...state, error })),
  // CLear dashboard Data
  on(DashboardActions.clearUserDashboardData, state => ({ ...state, userDashboardData: null }))
);

export function dashboardReducer(state: DashboardState | undefined, action: Action) {
  return reducer(state, action);
}
